export const UserRole = {
    TRAINER: "TRAINER",
    CLIENT: "CLIENT",
};
export const ChallengeFrequency = {
    DAILY: "DAILY",
    WEEKLY: "WEEKLY",
    ONCE: "ONCE",
};
export const ChallengeStatus = {
    ACTIVE: "ACTIVE",
    PAUSED: "PAUSED",
    ARCHIVED: "ARCHIVED",
};
export const CoinTransactionType = {
    EARN: "EARN",
    REDEEM: "REDEEM",
    BONUS: "BONUS",
};
export const TaskStatus = {
    OPEN: "OPEN",
    DONE: "DONE",
    CANCELLED: "CANCELLED",
};
export const PackageStatus = {
    ACTIVE: "ACTIVE",
    DEPLETED: "DEPLETED",
    EXPIRED: "EXPIRED",
};
export const LeadStage = {
    INQUIRY: "INQUIRY",
    TRIAL: "TRIAL",
    CONVERTED: "CONVERTED",
    LOST: "LOST",
};
export const LeadSource = {
    INSTAGRAM: "INSTAGRAM",
    REFERRAL: "REFERRAL",
    WEBSITE: "WEBSITE",
    OTHER: "OTHER",
    UNKNOWN: "UNKNOWN",
};
export const BookingType = {
    GYM: "GYM",
    ONLINE: "ONLINE",
    SELF: "SELF",
};
export const BookingStatus = {
    PENDING: "PENDING",
    CONFIRMED: "CONFIRMED",
    CANCELLED: "CANCELLED",
    COMPLETED: "COMPLETED",
};
